var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._b({ staticClass: "relative" }, "div", _vm.$attrs, false),
    [
      _c("div", {
        ref: "map",
        staticClass: "custom-google-map",
        class: _vm.mapElementClass,
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "overflow-hidden", staticStyle: { display: "none" } },
        [
          _c(
            "div",
            { ref: "popup", staticClass: "max-w-[19rem] -m-8" },
            [
              _vm.selectedMarker
                ? _c("offer-item", {
                    attrs: {
                      name: _vm.selectedMarker.title,
                      img: _vm.selectedMarker.images[0],
                      price: _vm.selectedMarker.price,
                      location: _vm.selectedMarker.location,
                      area: _vm.selectedMarker.area,
                      rooms: _vm.selectedMarker.rooms,
                      link: _vm.selectedMarker.href,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade-in" } }, [
        _vm.showZoom
          ? _c(
              "div",
              {
                staticClass:
                  "absolute right-4 bottom-4 pointer-events-none bg-white rounded overflow-hidden",
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "w-8 aspect-squar bg-white pointer-events-auto text-blue grid place-items-center border-b border-blue text-[1.5rem]",
                    attrs: { "aria-label": "Zoom in" },
                    on: {
                      click: function ($event) {
                        return _vm.zoom(true)
                      },
                    },
                  },
                  [_vm._v("\n        +\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "w-8 aspect-square bg-white pointer-events-auto text-blue grid place-items-center text-[1.5rem]",
                    attrs: { "aria-label": "Zoom out" },
                    on: {
                      click: function ($event) {
                        return _vm.zoom(false)
                      },
                    },
                  },
                  [_vm._v("\n        -\n      ")]
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }